export const ActionByRole = Object.freeze({
	avatar: 'avatar',
	call: 'call',
	extend: 'extend',
	leave: 'leave',
	leaveOwner: 'leaveOwner',
	kick: 'kick',
	mute: 'mute',
	rename: 'rename',
	send: 'send',
	deleteOwnMessage: 'deleteOwnMessage',
	deleteOthersMessage: 'deleteOthersMessage',
	deleteCompleteOwnMessage: 'deleteCompleteOwnMessage',
	userList: 'userList',
	changeOwner: 'changeOwner',
	changeManagers: 'changeManagers',
	update: 'update',
	delete: 'delete',
	readMessage: 'readMessage',
	openComments: 'openComments',
	subscribeToComments: 'subscribeToComments',
	openSidebar: 'openSidebar',
	pinMessage: 'pinMessage',
	setReaction: 'setReaction',
	createMeeting: 'createMeeting',
	createTask: 'createTask',
	createChildChat: 'createChildChat',
	openAvatarMenu: 'openAvatarMenu',
	openMessageMenu: 'openMessageMenu',
	openSidebarMenu: 'openSidebarMenu',
	updateInviteLink: 'updateInviteLink',
	manageGuestLink: 'manageGuestLink',
	createDocumentSign: 'createDocumentSign',
	createCalendarSlots: 'createCalendarSlots',
	changeMessagesAutoDeleteDelay: 'changeMessagesAutoDeleteDelay',
	attachToParent: 'attachToParent',
});

export const ChatActionGroup = Object.freeze({
	manageSettings: 'manageSettings',
	manageUi: 'manageUi',
	manageUsersAdd: 'manageUsersAdd',
	manageUsersDelete: 'manageUsersDelete',
	manageMessages: 'manageMessages',
	manageGuestInvites: 'manageGuestInvites',
	manageDelete: 'manageDelete',
});

export const ActionByUserType = Object.freeze({
	getChannels: 'getChannels',
	getMarket: 'getMarket',
	getOpenlines: 'getOpenlines',
	createCollab: 'createCollab',
	createCopilot: 'createCopilot',
	createChannel: 'createChannel',
	createChat: 'createChat',
	createConference: 'createConference',
	leaveCollab: 'leaveCollab',
	changeMessagesAutoDeleteDelay: 'changeMessagesAutoDeleteDelay',
	changeStickerPack: 'changeStickerPack',
	createStickerPack: 'createStickerPack',
	extend: 'extend',
	manageGuestLink: 'manageGuestLink',
});
